import React from "react";
import { IntroCont, Text1, Text2, Text4 } from "./FourCardStyledComp";

export default function Intro() {
  return (
    <IntroCont>
      <Text2>Reliable, efficient delivery</Text2>
      <Text1>Powered by Technology</Text1>
      <Text4>
        Our Artificial Intelligence powered tools use millions of project data
        points to ensure that your project is successful
      </Text4>
    </IntroCont>
  );
}
